var map = {
	"./": 162,
	"./cardapioSaurus/logos/icon.png": 494,
	"./cardapioSaurus/logos/logo.png": 495,
	"./file-exporter": 230,
	"./file-exporter.ts": 230,
	"./global/imagens/bg.png": 133,
	"./global/imagens/loading.gif": 496,
	"./global/imagens/ola.png": 313,
	"./global/imagens/sacolaVazia.svg": 314,
	"./global/imagens/semFoto.png": 175,
	"./global/imagens/triste.png": 217,
	"./index": 162,
	"./index.ts": 162,
	"./menuVip/logos/icon.png": 497,
	"./menuVip/logos/logo.png": 498,
	"./menuVip/logos/logo2.png": 499
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 493;